<ion-label>{{title}}</ion-label>
<div class="bar-wrapper">
  <div class="bar-background">
  </div>
  <div class="bar-pin" [style.left]="value*100+'%'"></div>
  </div>
